import { AFFECTED_BUNDLES_ACTIONS } from './affectedBundles.types'

/**
 * @param {import('./affectedBundles.types').AffectedBundlesSlice['status']} payload
 * @returns {import('./affectedBundles.types').AffectedBundlesStatusAction}
 */
export const setAffectedBundlesStatusAction = payload => ({
  type: AFFECTED_BUNDLES_ACTIONS.SET_AFFECTED_BUNDLES_STATUS,
  payload
})

/**
 * @param {import('../slice.types').SliceError} payload
 * @returns {import('./affectedBundles.types').AffectedBundlesErrorsAction}
 */
export const setAffectedBundlesErrorsAction = payload => ({
  type: AFFECTED_BUNDLES_ACTIONS.SET_AFFECTED_BUNDLES_ERRORS,
  payload
})

/**
 * @param {import('./affectedBundles.types').AffectedBundlesSlice} payload
 * @returns {import('./affectedBundles.types').AffectedBundlesAction}
 */
export const setAffectedBundlesAction = payload => ({
  type: AFFECTED_BUNDLES_ACTIONS.SET_AFFECTED_BUNDLES,
  payload
})
